import { Button, Checkbox, Col, Form, Input, InputNumber, Layout, Row } from 'antd';
import React, { useEffect } from 'react'
import { Add_CustomType_Api } from '../../API/CustomTypeApi';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
// =================================================================
export const AddCustomTypeComponent = ({ setLoading, showMessage, parentId, rowInserted, cancelInsert }) => {
  // =================================================================
  const [form] = Form.useForm()
  // =================================================================
  useEffect(() => {
    form.setFieldsValue({ isActive: true });
  }, []);
  // =================================================================
  const onSubmit = async (values) => {
    setLoading(true);
    try {
      values.parentId = parentId;
      let data = await Add_CustomType_Api(values);
      setLoading(false);
      if (data.messageStatus == "Successful") {
        showMessage(data.message, "Successful")
        rowInserted();
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور", "error")
    }
  };
  // =================================================================
  const onFinishFailed = (errorInfo) => {
    showMessage(errorInfo, "error")
  };
  // =================================================================
  return (
    <>
      <div className='sectionTitle'>
        <h2 >
          اضافه کردن لیست
        </h2>
      </div>
      <div className='container'>
        <Form
          name="basic"
          form={form}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="title"
            label="عنوان"
            rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
          >
            <Input placeholder='عنوان' />
          </Form.Item>

          <Form.Item
            name="code"
            label="کد"
          >
            <InputNumber />
          </Form.Item>

          <Form.Item
            name="isPrimary"
            valuePropName='checked'
            label="رکورد اصلی"
          >
            <Checkbox > </Checkbox>

          </Form.Item>

          <Form.Item
            name="orderIndex"
            label="ترتیب"
          >
            <InputNumber />
          </Form.Item>


          <Form.Item
            name="isActive"
            label="فعال"
            valuePropName='checked'
          >
            <Checkbox > </Checkbox>
          </Form.Item>
        </Form>
      </div>

      <Row className='sectionFooter'>
        <Col xs={0} sm={0} md={8} lg={16} xl={16} >
        </Col>
        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
          <Button
            style={{ width: '98%' }}
            className='btn-primary'
            htmlType="submit"
            onClick={() => form.submit()}>
            <CheckOutlined />
            ذخیره
          </Button>
        </Col>
        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
          <Button
            className='btn-secondary'
            style={{ width: '100%' }}
            onClick={() => cancelInsert()}>
            <RollbackOutlined />
            لغو </Button>
        </Col>
      </Row>
    </>

  )
}